import client from './client';

export const listApplications = (orgId) =>
  client.get('/api/applications', { params: orgId ? { orgId } : {} });

export const listRankedApplications = (orgId) =>
  client.get('/api/applications/ranking', { params: orgId ? { orgId } : {} });

export const createApplication = (data, orgId) =>
  client.post('/api/applications', data, { params: orgId ? { orgId } : {} });
